/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'translate';
import MenuItem from './MenuItem';
import LanguageSelect from './LanguageSelect';

const PersonalMenu = ({
  isAuthenticated, visible, onMenuClose, onLoginClick,
  /* onLogoutClick, */onSwitchBusinessPersonal, isMobile, onStartCampaignClick,
}) => (
  <div className={`Menu ${(visible) ? 'show' : ''} ${isMobile ? 'mobile' : ''}`} id="offCanvasMenu">
    {/* <LanguageSwitcher/>*/}
    <ul className="nav flex-column">
      {/* Personal Section */}
      {isAuthenticated && (
        <React.Fragment>
          <MenuItem onClick={onMenuClose} to="/i/home" icon="home">
            <FormattedMessage id="main.home" />
          </MenuItem>
          <MenuItem onClick={onMenuClose} to="/i/my-activity" icon="activity">
            <FormattedMessage id="main.my_activity" />
          </MenuItem>
          <MenuItem onClick={onMenuClose} to="/settings/notifications" icon="notifications">
            <FormattedMessage id="main.notifications" />
          </MenuItem>
          <MenuItem onClick={onMenuClose} href="https://www.2key.network/invite" icon="gift">
            <FormattedMessage id="main_menu.invite_a_friend" />
          </MenuItem>
          <li className="menu-border" />
          <MenuItem onClick={onStartCampaignClick} icon="rocket">
            <FormattedMessage id="main.create_a_smartlink" />
          </MenuItem>
          <MenuItem
            onClick={onSwitchBusinessPersonal}
            icon="page"
          >
            <FormattedMessage id="main_menu.switch_to_business" />
          </MenuItem>

          <li className="menu-border" />
        </React.Fragment>
      )}

      {/* General Links */}

      <MenuItem onClick={onMenuClose} href="https://help.2key.io/en/" icon="faq">
        <FormattedMessage id="main_menu.faq" />
      </MenuItem>
      <MenuItem onClick={onMenuClose} href="https://medium.com/2key" icon="blog">
        <FormattedMessage id="main_menu.blog" />
      </MenuItem>
      <MenuItem
        className="newBusiness"
        onClick={onMenuClose}
        href="https://www.2key.network"
        icon="about"
      >
        <FormattedMessage id="main.about_2key" />
      </MenuItem>
      {/* {!isAuthenticated && (
        <Fragment>
          <li className="menu-border" />
          <MenuItem
            className="switch-network"
            onClick={onMenuClose}
            href="https://www.2key.network"
          >
            <div className="switch-network__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.28 62.28"><path d="M58.14,39.27a27.36,27.36,0,0,0-12.6-28.56,2.46,2.46,0,0,0-1.89-.3,2.49,2.49,0,0,0-1.56,1.12,2.52,2.52,0,0,0-.3,1.9A2.49,2.49,0,0,0,42.91,15,22.32,22.32,0,0,1,53.35,37.64h-.21a8.51,8.51,0,1,0,5,1.63Zm-5,10.37a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,53.14,49.64Zm-13.4,5.29h0a22.1,22.1,0,0,1-8.59,1.71,22.63,22.63,0,0,1-15-5.72,8.5,8.5,0,1,0-7,3.72,8.7,8.7,0,0,0,3.07-.57,27.66,27.66,0,0,0,18.93,7.57,27.33,27.33,0,0,0,10.51-2.08,2.5,2.5,0,0,0-1.91-4.63ZM9.14,42.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,9.14,42.64ZM6,34.85h.18a2.52,2.52,0,0,0,2.5-2.32A22.21,22.21,0,0,1,23.56,13a8.49,8.49,0,1,0-.84-5,27.51,27.51,0,0,0-19,24.2A2.5,2.5,0,0,0,6,34.85ZM31.14,5.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,31.14,5.64Z" /></svg>
            </div>
            <div className="switch-network__text">
              {(window.CONFIG.mainNet > 1) && (
                <Fragment>
                  &nbsp;
                  {isMobile ?
                    <FormattedMessage id="" /> :
                    <FormattedMessage id="" />}
                </Fragment>
              )}
            </div>
          </MenuItem>
          <li className="menu-border" />
        </Fragment>
      )}*/}
      {!isAuthenticated && (
        <MenuItem onClick={onLoginClick} >
          <FormattedMessage id="main.login" />
        </MenuItem>
      )}
      {/* {isAuthenticated && window.CONFIG.mainNet > 1 && (
        <React.Fragment>
          <li className="menu-border" />
          <MenuItem
            className="newBusiness"
            onClick={onMenuClose}
            href="https://app.2key.network"
            icon="about"
            disabled
          >
            <FormattedMessage id="" />
            &nbsp;
            {(window.CONFIG.mainNet > 1) &&
              <React.Fragment>
                {'('}
                <FormattedMessage id="" />
                {')'}
              </React.Fragment>}
            {/* ({isMobile ?
              <FormattedMessage id="" /> :
              <FormattedMessage id="" />}) */}
      {/*    </MenuItem>
      </React.Fragment>
      )}*/}
      <li className="menu-border" />
      <MenuItem
        className="switch-network"
        onClick={onMenuClose}
        href={`//${(window.CONFIG.mainNet > 1) ? '2key.io' : 'test.2key.io'}`}
      >
        <div className="switch-network__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62.28 62.28"><path d="M58.14,39.27a27.36,27.36,0,0,0-12.6-28.56,2.46,2.46,0,0,0-1.89-.3,2.49,2.49,0,0,0-1.56,1.12,2.52,2.52,0,0,0-.3,1.9A2.49,2.49,0,0,0,42.91,15,22.32,22.32,0,0,1,53.35,37.64h-.21a8.51,8.51,0,1,0,5,1.63Zm-5,10.37a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,53.14,49.64Zm-13.4,5.29h0a22.1,22.1,0,0,1-8.59,1.71,22.63,22.63,0,0,1-15-5.72,8.5,8.5,0,1,0-7,3.72,8.7,8.7,0,0,0,3.07-.57,27.66,27.66,0,0,0,18.93,7.57,27.33,27.33,0,0,0,10.51-2.08,2.5,2.5,0,0,0-1.91-4.63ZM9.14,42.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,9.14,42.64ZM6,34.85h.18a2.52,2.52,0,0,0,2.5-2.32A22.21,22.21,0,0,1,23.56,13a8.49,8.49,0,1,0-.84-5,27.51,27.51,0,0,0-19,24.2A2.5,2.5,0,0,0,6,34.85ZM31.14,5.64a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,31.14,5.64Z" /></svg>
        </div>
        <div className="switch-network__text">
          {(window.CONFIG.mainNet > 1) ?
            <FormattedMessage id="main_menu.open_main_net" /> :
            <FormattedMessage id="main_menu.open_test_net" />}
        </div>
      </MenuItem>
    </ul>

    <LanguageSelect />
  </div>
);

PersonalMenu.propTypes = {
  isMobile: PropTypes.bool,
  visible: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  onMenuClose: PropTypes.func.isRequired,
  onSwitchBusinessPersonal: PropTypes.func.isRequired,
  onLoginClick: PropTypes.func.isRequired,
  onStartCampaignClick: PropTypes.func.isRequired,
  // onLogoutClick: PropTypes.func.isRequired,
};

export default PersonalMenu;
